import { apolloClient } from "@/plugins/vue-apollo.js";

export const createPromotionByAdmin = async (variables) => {
    try {
        const apiResponse = await apolloClient.mutate({
            mutation: require("../api/mutations/create_promotion_by_admin.graphql"),
            variables: variables
        })
        return apiResponse
    } catch (error) {
        console.error(error)
        return error
    }
}